var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hrbinefosa)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 25.5H7.25c-.525 0-.875-.35-.875-.875V5.375c0-.525.35-.875.875-.875H19.5c.525 0 .875.35.875.875V11.5c0 .525-.35.875-.875.875s-.875-.35-.875-.875V6.25h-10.5v17.5h10.5V18.5c0-.525.35-.875.875-.875s.875.35.875.875v6.125c0 .525-.35.875-.875.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 15.875H13.375c-.525 0-.875-.35-.875-.875s.35-.875.875-.875H26.5c.525 0 .875.35.875.875s-.35.875-.875.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 15.875a.794.794 0 0 1-.613-.262l-3.5-3.5a.846.846 0 0 1 0-1.226.846.846 0 0 1 1.226 0l3.5 3.5c.35.35.35.875 0 1.226a.794.794 0 0 1-.613.262z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 19.375a.794.794 0 0 1-.613-.262.846.846 0 0 1 0-1.226l3.5-3.5a.846.846 0 0 1 1.226 0c.35.35.35.875 0 1.226l-3.5 3.5a.794.794 0 0 1-.613.262z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hrbinefosa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(6.375 4.5)",
    d: "M0 0h21v21H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.ccde3672db383deb3836905fc45ef047.svg";
export { ForwardRef as ReactComponent };